import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { TableWrapper, UiList } from '@ru-digital-assets/ui-component';
import { format } from 'date-fns';

import UcpDetailsTop from '../components/ucp-sign/ucp-details-top/ucp-details-top';
import UcpDocs from '../components/ucp-sign/ucp-docs/ucp-docs';
import UcpHeader from '../components/ucp-sign/ucp-header/ucp-header';
import UcpSignForm from '../components/ucp-sign/ucp-sign-form/ucp-sign-form';
import LoadDocBtn from '../modules/load-doc-btn';
import { useAppDispatch } from '../store';
import {
  getSaleAgreement,
  setSigningInfo,
  signSale,
} from '../store/actions/operations-sign';
import { setOperationResult } from '../store/actions/sign-result';
import { RootState } from '../types';
import { downloadFile, getPdfFromBase64 } from '../utils/files/downloadFile';
import SalesParameters from '../components/SalesParameters';
import { useSign } from 'hooks';

const AssetsSellingSignContainer: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const companyInfo = useSelector(
    (state: RootState) => state.companiesInfo.companies
  );
  const decisionId = useSelector(
    (state: RootState) => state.operationsSign.data.saleCfa.decisionId
  );
  const decisionHash = useSelector(
    (state: RootState) => state.operationsSign.data.saleCfa.decisionHash
  );
  const doc = useSelector(
    (state: RootState) => state.operationsSign.data.saleCfa.decisionDoc
  );
  const loadingSign = useSelector(
    (state: RootState) => state.operationsSign.loading.saleCfaSign
  );
  const saleCfa: any = useSelector(
    (state: RootState) => state.operationsSign.data.saleCfa
  );
  const paymentTokens = useSelector(
    (state: RootState) => state.commonInfo.paymentTokens
  );

  console.log('saleCfa.status', saleCfa?.status);

  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
    usersCertificates,
  } = useSign();

  const currentCert = useMemo(() => {
    return usersCertificates.find(
      (certificate) => certificate.thumbprint === selectedCertificate?.value
    );
  }, [usersCertificates, selectedCertificate]);

  useEffect(() => {
    if (decisionId) {
      dispatch(
        getSaleAgreement({
          saleId: decisionId,
          signed: false,
          type: 'AGREEMENT',
        })
      );
    }
  }, [decisionId]);

  const decisionDocs = useMemo(() => {
    const docs = [];

    if (doc) {
      docs.push(
        <LoadDocBtn
          title="Договор купли-продажи"
          onSpecDownload={() => {
            const resultBlob = getPdfFromBase64(doc);
            downloadFile(
              resultBlob,
              'Договор купли-продажи.pdf',
              'application/pdf'
            );
          }}
        />
      );
    }

    return docs;
  }, [doc]);

  const onClose = () => history.push('/assets');

  const onSubmit = async () => {
    if (currentCert && decisionHash && decisionId) {
      const { pdfSigned } = await signEntity(decisionHash);
      if (pdfSigned) {
        dispatch(
          setSigningInfo({
            thumbprint: currentCert.thumbprint,
            name: currentCert.issuerName,
            date: `с ${format(
              new Date(currentCert.validFrom),
              'dd/MM/yyyy'
            )} до ${format(new Date(currentCert.validTo), 'dd/MM/yyyy')}`,
          })
        );
        dispatch(
          signSale({
            hash: decisionHash,
            signature: pdfSigned,
            operationId: decisionId,
          })
        )
          .then((action) => {
            const resultStatus = action.meta.requestStatus === 'fulfilled';
            dispatch(
              setOperationResult({ name: 'saleCfa', status: resultStatus })
            );
            history.push(`/history/selling-sign-info/${decisionId}`, {
              id: decisionId,
            });
          })
          .catch(() => {
            dispatch(setOperationResult({ name: 'saleCfa', status: false }));
            history.push('/assets/selling-sign-result');
          });
      }
    }
  };

  const initiatorList = [
    {
      label: 'Покупатель:',
      value: companyInfo[saleCfa.companyId]?.shortName,
    },
    {
      label: 'ИНН:',
      value: companyInfo[saleCfa.companyId]?.tin,
    },
  ];

  const recipientList = [
    {
      label: 'Продавец:',
      value: companyInfo[saleCfa.accountId]?.shortName,
    },
    {
      label: 'ИНН',
      value: companyInfo[saleCfa.accountId]?.tin,
    },
  ];

  return (
    <TableWrapper>
      <div className="ucp">
        <UcpHeader onClose={onClose} isSelling />
        <div className="ucp__body">
          <div className="ucp__left">
            <UcpDetailsTop
              operationString={`Заявка на продажу ${
                saleCfa?.tokenCount
              } токенов "${
                paymentTokens.find((p) => p.code === saleCfa?.tokenName)?.name
              }"`}
            />
            <div className="ucp__content">
              <div className="ucp__ontractors">
                <h3 className="h3">Детали операции:</h3>
                <div className="ucp__ontractors-body">
                  <div className="ucp__ontractors__left">
                    <UiList list={initiatorList} sm />
                  </div>
                  <div className="ucp__ontractors__right">
                    <UiList list={recipientList} sm />
                  </div>
                </div>
              </div>
              <UcpDocs docs={decisionDocs} />
              <UcpSignForm
                selected={selectedCertificate}
                onCertSelect={onUserSelectCertificate}
                onSubmit={onSubmit}
                disabled={!currentCert || loadingSign}
                backCallback={() => history.push(`/assets/selling`)}
                btnText="Подписать заявку"
                certsList={certificatesList}
              />
            </div>
          </div>
          <div className="ucp__right">
            <SalesParameters />
          </div>
        </div>
      </div>
    </TableWrapper>
  );
};

export default AssetsSellingSignContainer;
